module.exports = __webpack_public_path__ + "static/img/page_3.0fb5728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page1/page_3.png
// module id = ghKc
// module chunks = 1